module.exports = __webpack_public_path__ + "img/introduction.1ac7f7ab.jpg";